// extracted by mini-css-extract-plugin
export var chevron = "_2g-2";
export var chevronCollapsed = "_2g-3";
export var collapsibleHeader = "_2g-1";
export var container = "_2g-0";